// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `student-tile-container .required-section {
  background-color: #00375d;
}

student-tile-container .tile-holder {
  border: 1px solid #809baf;
  min-height: 100px;
  padding-top: 1.5em;
  padding-bottom: 15px;
  padding-left: 1.5%;
}

student-tile-container .no-top-border {
  border-top: none;
}

student-tile-container .no-gutters {
  padding-left: 0px;
  padding-right: 0px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/studentui/studentTileContainer.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["student-tile-container .required-section {\n  background-color: #00375d;\n}\n\nstudent-tile-container .tile-holder {\n  border: 1px solid #809baf;\n  min-height: 100px;\n  padding-top: 1.5em;\n  padding-bottom: 15px;\n  padding-left: 1.5%;\n}\n\nstudent-tile-container .no-top-border {\n  border-top: none;\n}\n\nstudent-tile-container .no-gutters {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
